<div class="container">
  <div class="row card">
    <div class="card-body col-md-6">
      <h2 class="title">Tools</h2>
      <button
        class="btn btn-primary my-2 text-white text-uppercase"
        (click)="openLg(transcript)">
        View video transcript
      </button>
    </div>
  </div>
</div>

<ng-template #transcript let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Video Transcript - Publish Your Stories</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body fs-6" style="height: 35vh">
    <p>
      Here we are! You're almost at the end. You're ready to publish the story.
      Congratulations! It might have been a tough road, but look what you've
      done. Now, once you publish, if you decide you want to make a few changes
      on your story, you can always go back. The TSOLife platform allows you to
      go back and work on your story a little bit more. Maybe you found another
      old photo that you want to upload. Those things are always available for
      you to change later.
    </p>
    <p>
      To publish a story you must have completed the attachment, writing, and
      details sections for all five stories. You'll know if your story is ready
      to publish once the icon turns from grey to green. If you try to click a
      grey publish icon, it will be indicated what sections need to be completed
      before continuing. If your story is ready, click the publish icon. You
      must have completed all five stories in full to publish them. Once you've
      finished publishing all your stories, you can go to your page and share
      that life story with the world. Thanks for writing your life stories with
      us! I hope it's been as rewarding for you as it has been for me in sharing
      my passion with you. You can always come back to TSOLife and write more
      stories. In fact, we hope you will! See you again!
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')">
      Close
    </button>
  </div>
</ng-template>
